<template>
    <div class="award-box">
        <el-tabs v-model="activeTab" @tab-click="handleClick">
            <el-tab-pane label="挖矿列表" name="MINING">
                <MiningList ref="miningList"></MiningList>
            </el-tab-pane>
            <el-tab-pane label="奖励列表" name="AWARD">
                <AwardList ref="awardList"></AwardList>
            </el-tab-pane>
            <el-tab-pane label="奖励详细" name="AWARDDETAIL">
                <AwardDetail ref="awardDetail"></AwardDetail>
            </el-tab-pane>
            <el-tab-pane label="挖矿记录" name="MININGRECORD">
                <MiningRecord ref="miningRecord"></MiningRecord>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import '../store';
    import MiningList from './miningList';
    import AwardList from './awardList';
    import AwardDetail from './awardDetail';
    import MiningRecord from './miningRecord';

    export default {
        name: 'Award',
        components: {
            MiningList,
            AwardList,
            AwardDetail,
            MiningRecord
        },

        data() {
            return {
                activeTab: "MINING", //激活项
            }
        },
        methods: {
            handleClick(tab, event) {
                if (this.activeTab == "MINING") {
                    this.$refs.miningList.reflashData();
                } else if (this.activeTab == "AWARD") {
                    this.$refs.awardList.reflashData();
                } else if (this.activeTab == "AWARDDETAIL") {
                    this.$refs.awardDetail.reflashData();
                } else if (this.activeTab == "MININGRECORD") {
                    this.$refs.miningRecord.reflashData();
                }
            }
        },
        mounted() {
            this.$refs.miningList.reflashData();
        }
    };
</script>

<style lang="less" scoped>
    .award-box {

    }
</style>

